import Vue from "vue";
import VueRouter from "vue-router";

// Routes
import { canNavigate } from "@/libs/acl/routeProtection";
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
} from "@/services/utils";
import adminPanel from "./routes/admin-painel";
import administrative from "./routes/administrative";
import dashboard from "./routes/dashboard";
import ui from "./routes/ui";
import pages from "./routes/pages";
import reports from "./routes/reports";

Vue.use(VueRouter);

const userData = getUserData();
const homeUrl = getHomeRouteForLoggedInUser(userData ? userData.role : null);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/", redirect: homeUrl },
    ...reports,
    ...adminPanel,
    ...administrative,
    ...dashboard,
    ...pages,
    ...ui,
    {
      path: "*",
      redirect: { name: "auth-login" },
    },
  ],
});

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn();

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: "auth-login" });

    // If logged in => not authorized
    return next({ name: "misc-not-authorized" });
  }

  // Routes with embedUrl are emplacamento pages — always require authentication
  if (to.meta.embedUrl && !isLoggedIn) {
    return next({ name: "auth-login" });
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    next(homeUrl);
  }

  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
